module.exports = __webpack_public_path__ + "r-v3/img/vacancy_detection_image.4bf3c44c.svg";